import { ROUND_DETAIL } from 'common/constant';
import TokenLocker2 from 'contracts/abiTokenLocker2.json';
import TokenLocker3 from 'contracts/abiTokenLocker3.json';
import TokenLockerKucoin from 'contracts/abiTokenLockerKucoin.json';

const list = [
  {
    key: 1,
    address: '0x86Cb723a6A05aDd747fEf8391E09A1bfD383B65c',
    title: ROUND_DETAIL.SEED_ROUND.title,
    type: ROUND_DETAIL.SEED_ROUND.type,
    abi: TokenLocker2.abi,
    isCountdown: true,
    nameRound: 'rowOne',
  },
  {
    key: 2,
    address: '0x8030bFCD5070e9C1E99C52e68D541E66d485203c',
    title: ROUND_DETAIL.PRIVATE_1_ROUND.title,
    type: ROUND_DETAIL.PRIVATE_1_ROUND.type,
    abi: TokenLocker2.abi,
    isCountdown: true,
    nameRound: 'rowTwo',
  },
  {
    key: 3,
    address: '0x5F633c6E0afab4635781258e2D875881fF631847',
    title: ROUND_DETAIL.PRIVATE_2_ROUND.title,
    type: ROUND_DETAIL.PRIVATE_2_ROUND.type,
    abi: TokenLocker2.abi,
    isCountdown: true,
    nameRound: 'rowThree',
  },
  {
    key: 4,
    address: '0x08c25144204568FE7eDFb9002Da0B6131cDE8A92',
    title: ROUND_DETAIL.STRATEGIC_ROUND.title,
    type: ROUND_DETAIL.STRATEGIC_ROUND.type,
    abi: TokenLocker2.abi,
    isCountdown: true,
    nameRound: 'rowThree',
  },
  {
    key: 5,
    address: '0x6771b51e064a8AC7fc86F664E21232261aB4300B',
    title: ROUND_DETAIL.LAUNCHPAD_ROUND.title,
    type: ROUND_DETAIL.LAUNCHPAD_ROUND.type,
    abi: TokenLocker3.output.abi,
    communityRound: true,
    isCountdown: true,
    nameRound: 'rowThree',
  },
  {
    key: 6,
    address: '0x6B21C95d020e348871bcB64a2A842200EFD43d82',
    title: ROUND_DETAIL.KUCOIN_ROUND.title,
    type: ROUND_DETAIL.KUCOIN_ROUND.type,
    abi: TokenLockerKucoin,
    isCountdown: true,
    nameRound: 'rowthree',
  },
  {
    key: 7,
    address: '0x8C13e0A2A1de45b2ACcAAaC22BF9D9B65609962a',
    title: ROUND_DETAIL.WHITE_LIST.title,
    type: ROUND_DETAIL.WHITE_LIST.type,
    abi: TokenLocker2.abi,
    isCountdown: true,
    nameRound: 'rowthree',
  },
];

export default list;
